import React, { useRef, useEffect, useState } from "react";
import { Tooltip } from "antd";

export default function AssignmentTitle({ title, description = false, is_data_debate = false }) {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [title]);

  const element = (
    <p ref={ref} className="assignment-title">
      {title}
    </p>
  );

  const descriptionElement = (
    <label ref={ref} className={`assignment-description ${is_data_debate ? "assignment-description-blank" : ""}`}>
      {title ? title : <div className="setBlanHyper">-</div>}
    </label>
  );

  return description ? (
    isTruncated ? (
      <Tooltip title={title}>{descriptionElement}</Tooltip>
    ) : (
      descriptionElement
    )
  ) : isTruncated ? (
    <Tooltip title={title}>{element}</Tooltip>
  ) : (
    element
  );
}
